import React from "react";
import ReactDOM from "react-dom/client";

import { SubHeaderApp } from "./SubHeaderApp";

ReactDOM.createRoot(
  document.getElementById("sub_header_fragment_root")!
).render(
  <React.StrictMode>
    <SubHeaderApp />
  </React.StrictMode>
);
